// RITA-1534 (Epic RITA-901) — Schriftgrößen im Vertragsdokument (reine Funktionen ohne DOM).
//
// Zwei Einstellungen (Entscheidung Julia 06./07.10.2026): die Grundgröße des ganzen Vertrags
// (`schrift.groessePt`, neue Vorlagen 11 pt; sie gilt für Vertragstext und Kopfzeile) und eine eigene
// Größe je Textlauf bzw. Platzhalter (`Zeichenformat.groessePt`). Die Fußzeile samt Seitenzahl hat eine
// feste Standardgröße von 9 pt; markierter Fußzeilentext kann eine eigene Größe bekommen. Gespeichert wird
// eine eigene Größe nur, wenn sie von der Grundgröße des Bereichs abweicht: Wer im Auswahlfeld die
// Grundgröße wählt, entfernt die eigene Größe, und der Text folgt künftig der Grundgröße. Text mit einer
// anderen Größe behält sie, auch wenn die Grundgröße später geändert wird.
import type { Bereich } from './positionen';
import type { Vertragsdokument } from './types';

/** Größen im Auswahlfeld der Werkzeugleiste. */
export const SCHRIFTGROESSEN_PT: readonly number[] = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28];

/** Wählbare Grundgrößen für den ganzen Vertrag. */
export const GRUNDGROESSEN_PT: readonly number[] = [8, 9, 10, 11, 12, 14];

/** Feste Standardgröße der Fußzeile einschließlich Seitenzahl (seit RITA-1525 so gedruckt). */
export const FUSSZEILE_GROESSE_PT = 9;

/** Größe, die Text ohne eigene Größe in diesem Bereich bekommt. */
export function grundgroesseVon(dokument: Vertragsdokument, bereich: Bereich): number {
  return bereich === 'fuss' ? FUSSZEILE_GROESSE_PT : dokument.schrift.groessePt;
}

/** Eigene Größe, die gespeichert wird: nichts, wenn die gewählte Größe die Grundgröße des Bereichs ist. */
export function eigeneGroesse(dokument: Vertragsdokument, bereich: Bereich, groessePt: number): number | undefined {
  return groessePt === grundgroesseVon(dokument, bereich) ? undefined : groessePt;
}
